import React from 'react'
import {ComingSoon} from "../components/ComingSoon/ComingSoon";


export function Home() {
    return(
        <ComingSoon/>
    )
}
